//
// Determine if the code executer here is a Bot or Not.
//
var spweb = spweb || {};
spweb.bon = (function(results) {
    function createCookie(name,value) {
        var date = new Date();
        //1 hour
        date.setTime(date.getTime()+(60*60*1000));
        var expires = "; expires="+date.toGMTString();
        document.cookie = name+"="+value+expires+"; path=/";
    }

    function SendStatefulResult() {
      // set a cookie
      createCookie("__bon", CompileResultsString());
    }

    function doPropertiesCheck() {
      //http://stackoverflow.com/questions/20862728/reliably-detecting-phantomjs-based-spam-bots
      //TBD more checks to add at https://github.com/ikarienator/phantomjs_hide_and_seek
      var window_names = ['_phantom', '__phantomas', 'webdriver', 'domAutomation'];
      var ret = 1;
      var reason = '';

      //check for node.js
      if (typeof module !== 'undefined' && module.exports) {
        reason = 'n';
        ret = 0;
      }

      for (var i = 0; i < window_names.length; i++) {
        if (window.hasOwnProperty(window_names[i])) {
          reason = window_names[i];
          ret = 0;
        }
      }

      //log reason
      if (ret == 0) {
        createCookie('__bond', reason);
      }

      return ret;
    }

    function doAntiSniffers() {
      var sniff_targets = ['userAgent', 'plugins', 'onLine'];
      for (var i = 0; i < sniff_targets.length; i++) {
        if (Object.getOwnPropertyDescriptor(navigator, sniff_targets[i]))
            return 0;
      }
  
      return 1;
    }

    function computeNonce(nonce) {
      return parseInt(nonce) * 42;
    }

    function checkWebGl() {
      var canvas = document.createElement("canvas"), glContext;

      try {
        glContext = canvas.getContext && (canvas.getContext("webgl") || canvas.getContext("experimental-webgl"));
      } catch(e) {
        glContext = false;
      }
  
      return (!!window.WebGLRenderingContext && !!glContext) ? 1 : 0;
    }


    function collectDetections(results) {
      var nonce = results[results.length-1];
      results.push(computeNonce(nonce));
      results.push(navigator.onLine ? 1 : 0);
      results.push(doPropertiesCheck());
      results.push(doAntiSniffers());
      results.push(checkWebGl());
  
      SendStatefulResult();
    }

    function CompileResultsString() {
      if (window.btoa) {
          return btoa(results.join('|'));
      } else {
          return '';
      }
    }

collectDetections(results);

}(results))
